import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Printer } from 'lucide-react';

export default function LobbySignQR() {
  // Production URL - Direct to Bitsy booking
  const bitsyUrl = "https://cpkc.hodlerinn.com/#/book?source=lobby";
  
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-white p-8">
      {/* Print Button - Hidden when printing */}
      <div className="print:hidden mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Lobby Sign QR Code</h1>
        <p className="text-gray-600 mb-2">Print this QR code for your physical lobby sign</p>
        <p className="text-sm text-green-600 font-mono mb-6">{bitsyUrl}</p>
        <button
          onClick={handlePrint}
          className="bg-orange-500 text-white px-8 py-3 rounded-lg font-semibold flex items-center gap-2 mx-auto hover:bg-orange-600"
        >
          <Printer className="w-5 h-5" />
          Print Lobby Sign
        </button>
      </div>

      {/* Printable Sign - Full Page */}
      <div className="max-w-2xl mx-auto">
        <div className="border-4 border-orange-500 rounded-3xl p-8 text-center bg-gradient-to-b from-gray-900 to-black print:border-2">
          <h1 className="text-5xl font-black text-orange-500 mb-2">WELCOME TO</h1>
          <h2 className="text-6xl font-black text-white mb-8">HODLER INN</h2>
          
          <p className="text-2xl text-orange-400 font-semibold mb-8">
            No Reservation? No Problem!
          </p>
          
          <div className="bg-white p-8 rounded-2xl inline-block mb-8">
            <QRCodeSVG 
              value={bitsyUrl}
              size={280}
              level="H"
              includeMargin={true}
            />
          </div>
          
          <div className="text-left text-white space-y-4 max-w-md mx-auto text-xl">
            <p className="flex items-start gap-3">
              <span className="text-2xl">📱</span>
              <span>Scan to meet <strong className="text-orange-400">Bitsy</strong>, our AI concierge</span>
            </p>
            <p className="flex items-start gap-3">
              <span className="text-2xl">✅</span>
              <span>Complete your check-in on your phone</span>
            </p>
            <p className="flex items-start gap-3">
              <span className="text-2xl">💰</span>
              <span><strong className="text-green-400">Save 10%</strong> with Crypto payment</span>
            </p>
            <p className="flex items-start gap-3">
              <span className="text-2xl">🔑</span>
              <span>We'll bring your key immediately!</span>
            </p>
          </div>
          
          <div className="mt-8 pt-6 border-t border-gray-700">
            <p className="text-gray-400 text-lg">
              (918) 653-7801 • 820 US-59, Heavener, OK
            </p>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style>{`
        @media print {
          body { 
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            margin: 0;
            padding: 0;
          }
          .print\\:hidden {
            display: none !important;
          }
          .print\\:border-2 {
            border-width: 2px !important;
          }
          @page {
            size: letter;
            margin: 0.5in;
          }
        }
      `}</style>
    </div>
  );
}
